import React from "react";

function SmallFrameBlossom({ className = "", rotate = 0 }) {
    return (
        <svg
            className={className}
            style={{ transform: `rotate(${rotate}deg)` }}
            width="74"
            height="48"
            viewBox="0 0 74 48"
            fill="none"
            aria-hidden="true"
        >
            <path d="M5 25 C 22 16, 42 15, 68 22" stroke="var(--wd-accent)" strokeWidth="1.1" strokeLinecap="round" opacity="0.85" />
            <path d="M20 23 C 26 14, 38 11, 49 15" stroke="var(--wd-accent)" strokeWidth="0.9" strokeLinecap="round" opacity="0.55" />
            <g fill="var(--wd-leaf)" opacity="0.72">
                <ellipse cx="22" cy="23" rx="8" ry="3.2" transform="rotate(-30 22 23)" />
                <ellipse cx="42" cy="17" rx="8" ry="3.2" transform="rotate(22 42 17)" />
                <ellipse cx="54" cy="22" rx="7" ry="3" transform="rotate(-18 54 22)" />
            </g>
            {[
                [16, 24, 7],
                [32, 16, 6],
                [48, 19, 7],
                [59, 26, 5.5],
            ].map(([cx, cy, r], i) => (
                <g key={i}>
                    {[0, 72, 144, 216, 288].map((angle) => (
                        <ellipse
                            key={angle}
                            cx={cx}
                            cy={cy - r * 0.45}
                            rx={r * 0.38}
                            ry={r * 0.62}
                            fill="var(--wd-rose)"
                            transform={`rotate(${angle} ${cx} ${cy})`}
                            opacity="0.92"
                        />
                    ))}
                    <circle cx={cx} cy={cy} r={r * 0.28} fill="var(--wd-rose)" />
                    <circle cx={cx} cy={cy} r={r * 0.1} fill="var(--wd-accent)" />
                </g>
            ))}
        </svg>
    );
}

export function FrameBlossoms({ className = "" }) {
    return (
        <div className={`wd-ornament-floral absolute inset-0 z-[2] pointer-events-none ${className}`} aria-hidden="true">
            <SmallFrameBlossom className="absolute left-[18px] top-[10px]" />
            <SmallFrameBlossom className="absolute right-[18px] top-[10px]" rotate={180} />
            <SmallFrameBlossom className="absolute bottom-[10px] left-[18px]" rotate={0} />
            <SmallFrameBlossom className="absolute bottom-[10px] right-[18px]" rotate={180} />
        </div>
    );
}

// "Ornate" gold divider with heart (inspired by reference card)
export function OrnateHeartDivider({ className = "", width = 220 }) {
    return (
        <svg className={`wd-ornament-floral ${className}`} width={width} height="40" viewBox="0 0 220 40" fill="none" aria-hidden="true">
            <g stroke="var(--wd-accent)" strokeWidth="1.2" fill="none" strokeLinecap="round">
                {/* left flourish */}
                <path d="M2 20 C 30 20, 40 10, 55 20 S 80 30, 95 20" />
                <path d="M15 20 C 25 14, 35 14, 45 20" opacity="0.55" />
                {/* right flourish */}
                <path d="M125 20 C 140 10, 165 30, 180 20 S 210 20, 218 20" />
                <path d="M175 20 C 185 14, 195 14, 205 20" opacity="0.55" />
            </g>
            {/* center heart */}
            <g>
                <path
                    d="M110 32 C 98 22, 98 10, 106 8 C 110 7, 113 10, 110 14 C 107 10, 110 7, 114 8 C 122 10, 122 22, 110 32 Z"
                    stroke="var(--wd-accent)"
                    strokeWidth="1.4"
                    fill="none"
                />
            </g>
        </svg>
    );
}

// small gold underline flourish (used under section titles)
export function GoldFlourish({ className = "" }) {
    return (
        <svg className={`wd-ornament-floral ${className}`} width="140" height="14" viewBox="0 0 140 14" fill="none" aria-hidden="true">
            <path d="M2 7 C 20 3, 40 11, 60 7" stroke="var(--wd-accent)" strokeWidth="1.1" fill="none" strokeLinecap="round" />
            <path d="M80 7 C 100 11, 120 3, 138 7" stroke="var(--wd-accent)" strokeWidth="1.1" fill="none" strokeLinecap="round" />
            <circle cx="70" cy="7" r="3" fill="var(--wd-accent)" />
            <circle cx="70" cy="7" r="1.3" fill="var(--wd-bg)" />
        </svg>
    );
}
